import { Note } from "../../../../../components/primitives/data-display/Note";

/** A document_sections_refresh job has no param to enter; this says what it will cover. */
export function DocumentSectionsRefreshParamsForm() {
  return (
    <Note>
      Covers every pending, ready and ingested document whose judge or excluded section file is
      missing from Storage when the job starts. Each is fetched again, its section files rewritten
      and its paragraphs embedded again; its scorecard and annotations are not touched. The Corpus
      scan investigation shows how many that is.
    </Note>
  );
}
